// What the office app keeps between screens about a company's people and work (the board's lanes, the
// review queue, an unsent booking) is forgotten on sign-out, so it never outlives a session on a
// shared office computer.
// A screen that keeps something adds its forget here, not to the header.

import { forgetBooking } from '../book-draft-cache.ts';
import { forgetLanes } from '../board-cache.ts';
import { forgetQueue } from '../review/queue-cache.ts';

export function forgetSessionCaches(): void {
  forgetLanes();
  forgetQueue();
  forgetBooking();
}
